import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Link } from 'react-router';
import { Row, Col } from 'react-flexbox-grid';
import Table from 'antd/lib/table';
import Menu from 'antd/lib/menu';
import Select from 'antd/lib/select';
import Input from 'antd/lib/input';
import Modal from 'antd/lib/modal';
import Popconfirm from 'antd/lib/popconfirm';
import { ResponsiveTable } from '../../../common/components/data-display';
import InterestSettingsForm from './InterestSettingsForm';
import InterestSettingsHistory from './InterestSettingsHistory';
import { formatDateTime } from '../../../common/utils/helpers';
import { Button } from 'antd';
import { accountRoles, accountRolesT } from '../../../common/enums';

const { Column } = Table;
const { Item: MenuItem } = Menu;
const { Option } = Select;
const { TextArea } = Input;

@translate()
export default class SettingList extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    categories: PropTypes.array.isRequired,

    // interest
    interestSettings: PropTypes.array.isRequired,
    interestSettingsHistory: PropTypes.array,
    onSubmitInterestSettings: PropTypes.func.isRequired,
    isUpdatingInterestSettings: PropTypes.bool.isRequired,

    // contract history
    generalContractHistory: PropTypes.array.isRequired,
    addNewEntry: PropTypes.func.isRequired,

    // ---- NEW: PSD2 Aggregation (admin) ----
    psd2Categories: PropTypes.array,                // [{ id, name, description }]
    psd2AggregationCriteria: PropTypes.array,       // [{ id, provider, iban?, searchString?, categoryId }]
    onFetchPsd2Categories: PropTypes.func,
    onCreatePsd2Category: PropTypes.func,
    onUpdatePsd2Category: PropTypes.func,
    onDeletePsd2Category: PropTypes.func,
    onFetchAggregationCriteria: PropTypes.func,
    onCreateAggregationCriteria: PropTypes.func,
    onUpdateAggregationCriteria: PropTypes.func,
    onDeleteAggregationCriteria: PropTypes.func,
  };

  state = {
    current: (this.props.categories && this.props.categories[0] && this.props.categories[0][0]) || 'interests',

    // Forms – categories
    newCategoryName: '',
    newCategoryDescription: '',

    // Forms – IBAN criterion
    newIbanCategoryId: undefined,
    newIban: '',
    newIbanProvider: '',
    showInvalidIbanWarning: false,

    // Forms – SearchString criterion
    newSearchCategoryId: undefined,
    newSearchString: '',
    newSearchProvider: '',

    // Edit modals
    editCategoryVisible: false,
    editCategoryData: null, // {id,name,description}

    editCriteriaVisible: false,
    editCriteriaData: null, // {id,categoryId,provider,iban?,searchString?}
  };

  componentDidMount() {
    const {
      onFetchPsd2Categories,
      onFetchAggregationCriteria,
    } = this.props;

    if (onFetchPsd2Categories) onFetchPsd2Categories({});
    if (onFetchAggregationCriteria) onFetchAggregationCriteria({});
  }

  handleMenuClick = ({ key: current }) => {
    this.setState({ current });
  };

  // ---------- Helpers ----------
  getCategoryNameById = (id) => {
    const { psd2Categories = [] } = this.props;
    const found = psd2Categories.find(c => c.id === id);
    return found ? found.name : '';
  };

  // ---------- Create handlers ----------
  createDefaultCategories = () => {
    const { onCreatePsd2Category, t } = this.props;
    if (!onCreatePsd2Category) return;

    const defaults = [
      'Splátky banky',
      'Splátky nebankovky',
      'Splátky paydays',
      'Gambling',
      'Konkurz',
      'Utility',
    ];

    defaults.forEach(name => {
      onCreatePsd2Category({ name, description: '', reloadOptions: {} });
    });
  };

  submitNewCategory = () => {
    const { onCreatePsd2Category } = this.props;
    const { newCategoryName, newCategoryDescription } = this.state;
    if (!onCreatePsd2Category || !newCategoryName) return;
    onCreatePsd2Category({ name: newCategoryName, description: newCategoryDescription, reloadOptions: {} });
    this.setState({ newCategoryName: '', newCategoryDescription: '' });
  };

  submitNewIbanCriteria = () => {
    const { onCreateAggregationCriteria, psd2AggregationCriteria = [] } = this.props;
    const { newIbanCategoryId, newIban, newIbanProvider } = this.state;
    if (!onCreateAggregationCriteria || !newIbanCategoryId || !newIban || !newIbanProvider) return;

    if ( psd2AggregationCriteria.some(c => !!c.iban && c.iban === newIban)) {
      this.setState({showInvalidIbanWarning: true})
      return
    };

    onCreateAggregationCriteria({
      categoryId: newIbanCategoryId,
      provider: newIbanProvider,
      iban: newIban,
      reloadOptions: {},
    });

    this.setState({ newIbanCategoryId: undefined, newIban: '', newIbanProvider: '' });
  };

  submitNewSearchCriteria = () => {
    const { onCreateAggregationCriteria } = this.props;
    const { newSearchCategoryId, newSearchString, newSearchProvider } = this.state;
    console.log(onCreateAggregationCriteria,newSearchCategoryId,newSearchProvider,newSearchString)
    if (!onCreateAggregationCriteria || !newSearchCategoryId || !newSearchString || !newSearchProvider) return;

    onCreateAggregationCriteria({
      categoryId: newSearchCategoryId,
      provider: newSearchProvider,
      searchString: newSearchString,
      reloadOptions: {},
    });

    this.setState({ newSearchCategoryId: undefined, newSearchString: '', newSearchProvider: '' });
  };

  // ---------- Edit/Delete handlers ----------
  openEditCategory = (category) => {
    this.setState({ editCategoryVisible: true, editCategoryData: { ...category } });
  };

  closeEditCategory = () => {
    this.setState({ editCategoryVisible: false, editCategoryData: null });
  };

  saveEditCategory = () => {
    const { onUpdatePsd2Category } = this.props;
    const { editCategoryData } = this.state;
    if (!onUpdatePsd2Category || !editCategoryData) return;

    const { id, name, description } = editCategoryData;
    onUpdatePsd2Category({ id, name, description, reloadOptions: {} });
    this.closeEditCategory();
  };

  openEditCriteria = (criterion) => {
    this.setState({ editCriteriaVisible: true, editCriteriaData: { ...criterion } });
  };

  closeEditCriteria = () => {
    this.setState({ editCriteriaVisible: false, editCriteriaData: null });
  };

  saveEditCriteria = () => {
    const { onUpdateAggregationCriteria } = this.props;
    const { editCriteriaData } = this.state;
    if (!onUpdateAggregationCriteria || !editCriteriaData) return;

    const { id, categoryId, provider, iban, searchString } = editCriteriaData;
    onUpdateAggregationCriteria({
      id,
      categoryId,
      provider,
      iban,
      searchString,
      reloadOptions: {},
    });
    this.closeEditCriteria();
  };

  deleteCategory = (id) => {
    const { onDeletePsd2Category } = this.props;
    if (onDeletePsd2Category) onDeletePsd2Category(id);
  };

  deleteCriteria = (id) => {
    const { onDeleteAggregationCriteria } = this.props;
    if (onDeleteAggregationCriteria) onDeleteAggregationCriteria(id);
  };

  // --- CSV helpers ---
  escapeCsv = (v) => {
    if (v === null || v === undefined) return '';
    const s = String(v);
    // quote if contains comma, quote or newline
    if (/[",\n]/.test(s)) {
      return `"${s.replace(/"/g, '""')}"`;
    }
    return s;
  };

  buildAggregationCsv = () => {
    const { t, psd2Categories = [], psd2AggregationCriteria = [] } = this.props;

    // Section 1: Categories
    const catHeader = [
      'ID kategórie',
      'Názov kategórie',
      'Popis kategórie',
    ];
    const catRows = psd2Categories.map((c) => [
      c.id,
      c.name,
      c.description || '',
    ]);

    // Section 2: Criteria (both IBAN + searchString)
    const critHeader = [
      'ID kritéria',
      'ID kategórie',
      'Názov kategórie',
      'Typ',       // IBAN | REŤAZEC
      'Hodnota',   // IBAN alebo hľadaný reťazec
      'Poskytovateľ',
    ];

    const catNameById = (id) => {
      const found = psd2Categories.find((c) => c.id === id);
      return found ? found.name : '';
      };

    const critRows = psd2AggregationCriteria.map((c) => {
      const isIban = !!c.iban;
      return [
        c.id,
        c.categoryId,
        catNameById(c.categoryId),
        isIban ? 'IBAN' : 'REŤAZEC',
        isIban ? (c.iban || '') : (c.searchString || ''),
        c.provider || '',
      ];
    });

    // Compose CSV string with two sections
    const lines = [];

    // Categories block
    lines.push(catHeader.map(this.escapeCsv).join(', '));
    catRows.forEach((r) => lines.push(r.map(this.escapeCsv).join(', ')));

    // blank line between sections
    lines.push('');

    // Criteria block
    lines.push(critHeader.map(this.escapeCsv).join(', '));
    critRows.forEach((r) => lines.push(r.map(this.escapeCsv).join(', ')));

    return lines.join('\n');
  };

  downloadAggregationCsv = () => {
    const csv = this.buildAggregationCsv();
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `psd2_aggregation_${new Date().toISOString().slice(0,10)}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  // ---------- Render blocks ----------
  renderPsd2Aggregation() {
    const { t, psd2Categories = [], psd2AggregationCriteria = [] } = this.props;

    const ibanCriteria = psd2AggregationCriteria.filter(c => !!c.iban);
    const searchCriteria = psd2AggregationCriteria.filter(c => !!c.searchString);

    const {
      newCategoryName, newCategoryDescription,
      newIbanCategoryId, newIban, newIbanProvider,
      newSearchCategoryId, newSearchString, newSearchProvider,
      editCategoryVisible, editCategoryData,
      editCriteriaVisible, editCriteriaData,
      showInvalidIbanWarning,
    } = this.state;

    if (showInvalidIbanWarning){
      setTimeout(() => {this.setState({showInvalidIbanWarning: false })}, 5000);
    }

    return (
      <div className="psd2-aggregation-settings">
        <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 12 }}>
          <Button onClick={this.downloadAggregationCsv}>
            {t('Stiahnuť CSV (kategórie + kritériá)')}
          </Button>
        </div>
        {/* Create Category */}
        <h2 style={{ marginTop: 12 }}>{t('Vytvorenie novej kategórie')}</h2>
        <Row>
          <Col xs={12} md={6}>
            <Input
              placeholder={t('Názov kategórie')}
              value={newCategoryName}
              onChange={e => this.setState({ newCategoryName: e.target.value })}
              style={{ marginBottom: 8 }}
            />
            <TextArea
              placeholder={t('Popis (voliteľné)')}
              value={newCategoryDescription}
              onChange={e => this.setState({ newCategoryDescription: e.target.value })}
              autosize={{ minRows: 2, maxRows: 4 }}
              style={{ marginBottom: 8 }}
            />
            <Button type="primary" onClick={this.submitNewCategory}>
              {t('Pridať kategóriu')}
            </Button>
          </Col>
        </Row>

        {/* Add IBAN */}
        <h2 style={{ marginTop: 24 }}>{t('Pridanie IBAN do kategórie')}</h2>
        {!!showInvalidIbanWarning && <span style={{color: 'red'}}>{t('Zadaný IBAN už je priradený niektorej kategórii')}</span>}
        <Row>
          <Col xs={12} md={8}>
            <Row>
              <Col xs={12} md={4} style={{ marginBottom: 8 }}>
                <Select
                  placeholder={t('Kategória')}
                  value={newIbanCategoryId}
                  onChange={val => this.setState({ newIbanCategoryId: val })}
                  style={{ width: '100%' }}
                >
                  {psd2Categories.map(c => <Option key={c.id} value={c.id}>{c.name}</Option>)}
                </Select>
              </Col>
              <Col xs={12} md={4} style={{ marginBottom: 8 }}>
                <Input
                  placeholder={t('IBAN')}
                  value={newIban}
                  onChange={e => this.setState({ newIban: e.target.value })}
                />
              </Col>
              <Col xs={12} md={4} style={{ marginBottom: 8 }}>
                <Input
                  placeholder={t('Poskytovateľ')}
                  value={newIbanProvider}
                  onChange={e => this.setState({ newIbanProvider: e.target.value })}
                />
              </Col>
            </Row>
            <Button type="primary" onClick={this.submitNewIbanCriteria}>
              {t('Pridať IBAN')}
            </Button>
          </Col>
        </Row>

        {/* Add Search String */}
        <h2 style={{ marginTop: 24 }}>{t('Pridanie hľadaného reťazca do kategórie')}</h2>
        <Row>
          <Col xs={12} md={8}>
            <Row>
              <Col xs={12} md={4} style={{ marginBottom: 8 }}>
                <Select
                  placeholder={t('Kategória')}
                  value={newSearchCategoryId}
                  onChange={val => this.setState({ newSearchCategoryId: val })}
                  style={{ width: '100%' }}
                >
                  {psd2Categories.map(c => <Option key={c.id} value={c.id}>{c.name}</Option>)}
                </Select>
              </Col>
              <Col xs={12} md={4} style={{ marginBottom: 8 }}>
                <Input
                  placeholder={t('Hľadaný reťazec')}
                  value={newSearchString}
                  onChange={e => this.setState({ newSearchString: e.target.value })}
                />
              </Col>
              <Col xs={12} md={4} style={{ marginBottom: 8 }}>
                <Input
                  placeholder={t('Poskytovateľ')}
                  value={newSearchProvider}
                  onChange={e => this.setState({ newSearchProvider: e.target.value })}
                />
              </Col>
            </Row>
            <Button type="primary" onClick={this.submitNewSearchCriteria}>
              {t('Pridať reťazec')}
            </Button>
          </Col>
        </Row>

        {/* Categories list */}
        <h2 style={{ marginTop: 24 }}>{t('Zoznam kategórií')}</h2>
        <ResponsiveTable dataSource={psd2Categories} rowKey={c => c.id} pagination={false}>
          <Column title={t('Názov')} dataIndex="name" key="name" />
          <Column title={t('Popis')} dataIndex="description" key="description" />
          <Column
            title={t('Akcie')}
            key="actions"
            render={(text, record) => (
              <span>
                <Button size="small" onClick={() => this.openEditCategory(record)} style={{ marginRight: 8 }}>
                  {t('Upraviť')}
                </Button>
                <Popconfirm title={t('Naozaj chcete vymazať?')} onConfirm={() => this.deleteCategory(record.id)}>
                  <Button size="small" type="danger">{t('Vymazať')}</Button>
                </Popconfirm>
              </span>
            )}
          />
        </ResponsiveTable>

        {/* IBAN list */}
        <h2 style={{ marginTop: 24 }}>{t('Zoznam IBANov')}</h2>
        <ResponsiveTable dataSource={ibanCriteria} rowKey={c => c.id} pagination={false}>
          <Column
            title={t('Kategória')}
            dataIndex="categoryId"
            key="cat"
            render={(value) => <span>{this.getCategoryNameById(value)}</span>}
          />
          <Column title={t('IBAN')} dataIndex="iban" key="iban" />
          <Column title={t('Poskytovateľ')} dataIndex="provider" key="provider" />
          <Column
            title={t('Akcie')}
            key="actions"
            render={(text, record) => (
              <span>
                <Button size="small" onClick={() => this.openEditCriteria(record)} style={{ marginRight: 8 }}>
                  {t('Upraviť')}
                </Button>
                <Popconfirm title={t('Naozaj chcete vymazať?')} onConfirm={() => this.deleteCriteria(record.id)}>
                  <Button size="small" type="danger">{t('Vymazať')}</Button>
                </Popconfirm>
              </span>
            )}
          />
        </ResponsiveTable>

        {/* Search strings list */}
        <h2 style={{ marginTop: 24 }}>{t('Zoznam hľadaných reťazcov')}</h2>
        <ResponsiveTable dataSource={searchCriteria} rowKey={c => c.id} pagination={false}>
          <Column
            title={t('Kategória')}
            dataIndex="categoryId"
            key="cat2"
            render={(value) => <span>{this.getCategoryNameById(value)}</span>}
          />
          <Column title={t('Hľadaný reťazec')} dataIndex="searchString" key="searchString" />
          <Column title={t('Poskytovateľ')} dataIndex="provider" key="provider2" />
          <Column
            title={t('Akcie')}
            key="actions2"
            render={(text, record) => (
              <span>
                <Button size="small" onClick={() => this.openEditCriteria(record)} style={{ marginRight: 8 }}>
                  {t('Upraviť')}
                </Button>
                <Popconfirm title={t('Naozaj chcete vymazať?')} onConfirm={() => this.deleteCriteria(record.id)}>
                  <Button size="small" type="danger">{t('Vymazať')}</Button>
                </Popconfirm>
              </span>
            )}
          />
        </ResponsiveTable>

        {/* Edit category modal */}
        <Modal
          title={t('Upraviť kategóriu')}
          visible={editCategoryVisible}
          onOk={this.saveEditCategory}
          onCancel={this.closeEditCategory}
          okText={t('Uložiť')}
          cancelText={t('Zrušiť')}
        >
          {editCategoryData && (
            <div>
              <Input
                style={{ marginBottom: 8 }}
                value={editCategoryData.name}
                onChange={e => this.setState({ editCategoryData: { ...editCategoryData, name: e.target.value } })}
                placeholder={t('Názov kategórie')}
              />
              <TextArea
                autosize={{ minRows: 2, maxRows: 4 }}
                value={editCategoryData.description}
                onChange={e => this.setState({ editCategoryData: { ...editCategoryData, description: e.target.value } })}
                placeholder={t('Popis')}
              />
            </div>
          )}
        </Modal>

        {/* Edit criterion modal */}
        <Modal
          title={t('Upraviť kritérium')}
          visible={editCriteriaVisible}
          onOk={this.saveEditCriteria}
          onCancel={this.closeEditCriteria}
          okText={t('Uložiť')}
          cancelText={t('Zrušiť')}
        >
          {editCriteriaData && (
            <div>
              <Select
                style={{ width: '100%', marginBottom: 8 }}
                value={editCriteriaData.categoryId}
                onChange={val => this.setState({ editCriteriaData: { ...editCriteriaData, categoryId: val } })}
              >
                {psd2Categories.map(c => <Option key={c.id} value={c.id}>{c.name}</Option>)}
              </Select>

              <Input
                style={{ marginBottom: 8 }}
                value={editCriteriaData.provider}
                onChange={e => this.setState({ editCriteriaData: { ...editCriteriaData, provider: e.target.value } })}
                placeholder={t('Poskytovateľ')}
              />

              {/* Show IBAN input if this is an IBAN criterion */}
              {'iban' in editCriteriaData ? (
                <Input
                  style={{ marginBottom: 8 }}
                  value={editCriteriaData.iban || ''}
                  onChange={e => this.setState({ editCriteriaData: { ...editCriteriaData, iban: e.target.value } })}
                  placeholder={t('IBAN')}
                />
              ) : null}

              {/* Show SearchString input if this is a searchString criterion */}
              {'searchString' in editCriteriaData ? (
                <Input
                  value={editCriteriaData.searchString || ''}
                  onChange={e => this.setState({ editCriteriaData: { ...editCriteriaData, searchString: e.target.value } })}
                  placeholder={t('Hľadaný reťazec')}
                />
              ) : null}
            </div>
          )}
        </Modal>
      </div>
    );
  }

  renderContent() {
    const { current } = this.state;

    if (current === 'interests') {
      const { interestSettings, interestSettingsHistory, onSubmitInterestSettings, isUpdatingInterestSettings } = this.props;

      return (
        <div>
          <InterestSettingsForm
            interestSettings={interestSettings}
            onSubmit={onSubmitInterestSettings}
            isUpdating={isUpdatingInterestSettings}
          />
          <InterestSettingsHistory history={interestSettingsHistory} />
        </div>
      );
    }

    if (current === 'contract') {
      const { t, generalContractHistory, addNewEntry } = this.props;

      return (
        <div>
          <Button type="primary" onClick={() => addNewEntry(accountRoles.DEBTOR)} style={{ marginRight: 8 }}>
            {t('Pridať nový záznam pre dlžníka')}
          </Button>
          <Button type="primary" onClick={() => addNewEntry(accountRoles.CREDITOR)}>
            {t('Pridať nový záznam pre investora')}
          </Button>
          <ResponsiveTable dataSource={generalContractHistory} rowKey={entry => entry.id} pagination={false}>
            <Column
              title={t('Dátum nahratia verzie')}
              dataIndex="dateUpdated"
              key="dateUpdated"
              width="70%"
              render={value => <span>{formatDateTime(value)}</span>}
            />
            <Column
              title={t('Rola')}
              dataIndex="role"
              key="role"
              width="30%"
              render={value => <span>{accountRolesT[value]}</span>}
            />
          </ResponsiveTable>
        </div>
      );
    }

    if (current === 'psd2Agg') {
      return this.renderPsd2Aggregation();
    }

    const [category, settings] = this.props.categories.find(([category]) => category === current);
    return <SettingsTableT title={category} settings={settings} key={category} />;
  }

  render() {
    const { categories, t } = this.props;
    const { current } = this.state;

    return (
      <div>
        <Row>
          <Col xs={12} md={7}>
            <h1>{t('Nastavenia systému')}</h1>
          </Col>

          <Col xs={12} md={5}>
            <Menu onClick={this.handleMenuClick} selectedKeys={[current]} mode="horizontal">
              {categories.map(([category]) => <MenuItem key={category}>{t(category)}</MenuItem>)}
              <MenuItem key="interests">{t('Úroky')}</MenuItem>
              <MenuItem key="contract">{t('Rámcové zmluvy')}</MenuItem>
              <MenuItem key="psd2Agg">{t('Agregácia transakcií (PSD2)')}</MenuItem>
            </Menu>
          </Col>
        </Row>

        <div className="padded">{this.renderContent()}</div>
      </div>
    );
  }
}

const SettingsTable = ({ title, settings, t }) => (
  <div>
    <h2 style={{ marginTop: 20 }}>{t(title)}</h2>
    <ResponsiveTable dataSource={settings} rowKey={setting => setting.id} pagination={false}>
      <Column
        title={t('Názov')}
        dataIndex="key"
        key="name"
        width="70%"
        render={key => (
          <div>
            <strong>{t(`SETTING_${key}`)}</strong>
            <p>{t(`SETTING_${key}_DESC`)}</p>
          </div>
        )}
      />
      <Column
        title={t('Hodnota')}
        dataIndex="value"
        key="value"
        render={(value, setting) => {
          if (setting.type === 'boolean') {
            return <span>{value == '1' ? t('áno') : t('nie')}</span>;
          }
          return <span>{value}</span>;
        }}
      />
      <Column
        title={t('Akcie')}
        key="action"
        render={(text, setting) => (
          <span>
            <Link to={`/admin/settings/${setting.id}`}>{t('Detail')}</Link>
          </span>
        )}
      />
    </ResponsiveTable>
  </div>
);

const SettingsTableT = translate()(SettingsTable);



// WEBPACK FOOTER //
// ./src/features/setting-management/components/SettingList.js